module.exports = __webpack_public_path__ + "img/images_homebanner_1_1.7bfb1926.png";